import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';
import modalSelectModalidadPago from '../../shared/components/modal-select-modalidad-pago/modal-select-modalidad-pago.view.html';

let inject = [
  '$scope',
  '$state',
  '$rootScope',
  'SharedService',
  'ngAuthSettings',
  'CatalogService',
  '$uibModal',
  '$timeout',
  'CartService'
];

class FeaturedProductsController {
  constructor($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout, CartService) {
    this.$state = $state;
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.CatalogService = CatalogService;
    this.CartService = CartService;
    this.$timeout = $timeout;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
  }

  $onInit() {
    this.getFeaturedProducts();
  }

  getFeaturedProducts() {
    let userId = '';
    try { userId = this.shCtrl.currentUser.userId; }
    catch (e) { }
    this.CatalogService.getFeaturedProducts(userId, 10).then(response => {
      this.featuredProducts = response;
      this.featuredProducts1 = [];
      this.featuredProducts2 = [];
      if (response.length) {
        response.forEach((valFor, indexFor) => {
          if (indexFor <= ((response.length - 1) / 2) || response.length < 8) {
            this.featuredProducts1.push(valFor);
          } else {
            this.featuredProducts2.push(valFor);
          }
        });
      }
      this.initRelatedProductsCarousel();
      // initBrandsCarousel();

      this.loadingRelatedProducts = false;
    }).catch(error => {

    });
  }

  modalConfirmation(products, quantity) {

    this.productAdded = products;
    this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
    this.productAdded.price = products.itemPrice;
    this.productAdded.discount = products.discountValue;
    this.productAdded.ivaValue = products.taxValue;
    this.productAdded.quantity = quantity;
    this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue + products.taxImpConsumoValue) * quantity;

    $('#productList').modal('toggle');

    this.$scope.$emit('onUpdateCart', 'modalResponseItems');
}

  initRelatedProductsCarousel() {
    this.$timeout(function () {
      let purchasedItems = $('.purchased-items-slider.owl-carousel');
      purchasedItems.owlCarousel({
        items: 4,
        itemsDesktop: [1199, 3],
        itemsDesktopSmall: [979, 2],
        itemsTablet: [768, 2],
        itemsMobile: [479, 1],
        slideSpeed: 400,
        autoPlay: 8000,
        stopOnHover: true,
        navigation: false,
        pagination: false,
        responsive: true,
        mouseDrag: false,
        autoHeight: true
      }).data('navigationBtns', ['#purchased-items-slider-prev', '#purchased-items-slider-next']);
      purchasedItems.each(function () {
        let $this = $(this),
          owlCarousel = $this.data('owlCarousel'),
          owlBtns = $this.data('navigationBtns'),
          prevBtn, nextBtn;

        if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
          return;
        }

        for (let key in owlBtns) {
          if (owlBtns[key].indexOf('next') === -1) {
            prevBtn = $(owlBtns[key]);
          } else {
            nextBtn = $(owlBtns[key]);
          }
        }

        prevBtn.on('click touchstart', function (e) {
          owlCarousel.prev();
          e.preventDefault();
        });

        nextBtn.on('click touchstart', function (e) {
          owlCarousel.next();
          e.preventDefault();
        });
      });

      $('.add-tooltip').tooltip();
    }, 1000);
  }

  setItemToAddToCart(product) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalQuantityCart,
      controller: 'ModalQuantityCartController',
      controllerAs: 'mdCtrl',
      size: 'sm',
      resolve: {
        product: () => product
      }
    });
    modalInstance.result.then(result => {
      if (result.product.id && result.quantity) {
        let userId = '', cart = null;
        try { userId = this.shCtrl.globals.currentUser.userId; } catch (e) { }
        try { cart = this.shCtrl.cart; } catch (e) { }
        this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(response => {
          if (!response.error) {
            if (!response.pesoValidoBodega && response.modalidadParametrizada) {
              this.cambiarSucursalVolumenItemMostrarMedioEnvio(response,product, result.quantity);
            } else if (!response.pesoValidoBodega && !response.modalidadParametrizada) {
              this.cambiarSucursalVolumenItems(response, cart, product, result.quantity);
            } else if (response.pesoValidoBodega && response.modalidadParametrizada) { // Si el peso de la bodega es valido y la modalidad no esta en el carrito
              this.showModalSelectModalidadPago(response, product, result.quantity);
            } else {
              this.$scope.$emit('onUpdateCart');
              let modalInstance2 = this.$uibModal.open({
                animation: true,
                template: modalConfirmationCart,
                controller: 'ModalConfirmationController',
                controllerAs: 'mdCtrl',
                size: 'lg',
                resolve: {
                  product: () => product
                }
              });
            }
          } else {
            let options = {
              title: '',
              isHtml: true,
              content: response.message,
              size: '',
              showBottonCancel: false,
              textActionCancel: '',
              textAction: 'Aceptar'
            };
            this.messageResponse(options);
          }
        }).catch(reason => {
          let options = {
            title: '',
            isHtml: false,
            content: reason,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar'
          };
          this.messageResponse(options);
        });
      }
    }).catch(error => {

    });
  }

  updateFavoriteProducts(product) {
    product.isSettingAsFavorite = true;
    let userId = '';
    try { userId = this.shCtrl.globals.currentUser.userId; }
    catch (e) { }
    if (userId) {
      let data = {
        'productId': product.id,
        'userId': userId,
        'setFavorite': !product.isFavorite
      };
      this.CatalogService.updateFavoriteProducts(data).then(response => {
        product.isFavorite = !product.isFavorite;
        product.isSettingAsFavorite = false;
      }).catch(error => {
        product.isSettingAsFavorite = false;
        let options = {
          title: '',
          isHtml: false,
          content: 'Ha ocurrido un error al actualizar el producto',
          size: '',
          showBottonCancel: false,
          textActionCancel: '',
          textAction: 'Aceptar'
        };
        this.messageResponse(options);
      });
    }
  }

  messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller: 'ModalResponseController',
      controllerAs: 'mdCtrl',
      size: options.size,
      resolve: {
        modalOptions: () => options
      }
    });
    modalInstance.result.then(() => {
      if (callAcept) {
        callback();
      }
    }).catch(reason => {
      if (callCancel) {
        callbackCancel();
      }
    });
  }

  showModalSelectModalidadPago(modalidadesPago, product,quantity) {

    let options = {
        userData: this.shCtrl.globals,
        branches: this.shCtrl.globals.currentUser.operatingCenters,
        currentBranch: this.shCtrl.globals.currentClient.operatingCenter,
        cmsMessage: this.shCtrl.globalParams.cmsInfo,
        modalidadesPago: modalidadesPago
    };
    let modalInstance = this.$uibModal.open({
        animation: true,
        static: true,
        template: modalSelectModalidadPago,
        controller: 'ModalSelectModalidadController',
        controllerAs: 'mdCtrl',
        backdrop: 'static',
        keyboard: false,
        size: 'lg',
        resolve: {
            modalOptions: () => options
        }
    });
    modalInstance.result.then(result => {
        this.modalConfirmation(product, quantity);
    }).catch(reason => {

    });
}

cambiarSucursalVolumenItems(response, cart , product, quantity) {
    let cartId = cart.cartId
    let responseData = response
    this.CartService.getShippingMode(cartId).then(response => {
        if (response.modalidad) {
            this.setSucursalesPorModalidad(response,cartId,product, quantity);
        } else {
            this.obtenerSucursalSecundaria(cartId, product, quantity);
        }
    });
}

setSucursalesPorModalidad(response, cartId, product, quantity) {
    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idUsuario = this.shCtrl.globals.currentUser.userId;
    let currentClient  = this.SessionService.get('currentClient');
    let idSucursalActual = currentClient.operatingCenter.id;
    let data = {
        'userId': idUsuario,
        'ciudadId': idCiudad
    };
    let tipoModalidad = response.modalidad.tipo_modalidad;
    // Si la modalidad es recoge 
    if (tipoModalidad == 0) {
        this.CartService.getSecondaryBranch(data).then(response => {
            let idSucursalSecundaria = response.listaSucursales[0].id;
            if (idSucursalSecundaria != null) {
              if(idSucursalSecundaria != idSucursalActual){
                this.setSucursalSecundariaRecogeEntrega(idSucursalSecundaria, idUsuario, product, quantity);
              }else{
                this.modalConfirmation(product, quantity);
              }
            }
        });
        this.CartService.updateDateCart(cartId).then(response => {
            return response;
        });
        // Si es a domicilio 
    } else {
        this.CartService.getSecondaryBranch(data).then(response => {
            let idSucursalSecundaria = response.listaSucursales[0].id;
            let idCiudad = response.listaSucursales[0].ciudad_id;

            if (idCiudad != null && idSucursalSecundaria != null && cartId != null) {
                this.CartService.updatePromiseCart(cartId, idSucursalSecundaria, idCiudad).then(response => {
                    let aplicaServicioDescargue = response.aplicaServicioDescargue;
                    if (idSucursalSecundaria != null) {
                      if(idSucursalSecundaria != idSucursalActual){
                        this.setSucursalSecundariaTipoDomicilio(idSucursalSecundaria, idUsuario, aplicaServicioDescargue, product, quantity);
                      }else{
                        this.modalConfirmation(product, quantity);
                      }
                    }
                });
            }
        });
    }
}

setSucursalSecundariaRecogeEntrega(idSucursal, userId, product, quantity) {

    let mensajeCambioSucursal = '';
    let mensajeCambioHorarioBodega = '';
    let allMessage = [];
    try {
        mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
        mensajeCambioHorarioBodega = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_HORARIO_BODEGA;
        allMessage.push(mensajeCambioSucursal);
        allMessage.push(mensajeCambioHorarioBodega);            

    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
        if (!response.error) {
            // Set the current client
            try {
                let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                newCurrentClient.operatingCenter = response.branch;
                newCurrentClient.seller = response.seller;
                this.SessionService.put('currentClient', newCurrentClient);
                this.SessionService.put('cartId', response.cartID);
                this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
                this.shCtrl.userData.globals.currentClient.seller = response.seller;

                this.$rootScope.$broadcast('actualizarHeader',response.branch);
                this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId}).then(response =>{
                  if(!response.error){
                    if (allMessage !== null) {
                      this.showModalAllMessage(allMessage, product, quantity);
                    }
                  }
                });
            } catch (e) {
            }
        } else {
            console.log('Ocurrio un erro al cambiar la sucursal')
        }
    }).catch(reason => {
        this.state.saving = false;
        this.state.error = true;
    });
}

setSucursalSecundariaTipoDomicilio(idSucursal, userId, aplicaServicioDescargue,product, quantity) {

    let mensajeCambioSucursal = '';
    let mensajeDestinoNoDisponilble = '';
    let mensajeCambioPromesa = '';
    let allMessage =[];
    
    try {
        mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
        mensajeCambioPromesa = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_PROMESA;
        allMessage.push(mensajeCambioSucursal);
        allMessage.push(mensajeCambioPromesa);
        
        if (!aplicaServicioDescargue) {
            mensajeDestinoNoDisponilble =  this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_INFORMATITVO_DESTINOS_NO_DISPONIBLES;
            allMessage.push(mensajeDestinoNoDisponilble);
        } 

    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
        if (!response.error) {
            // Set the current client
            try {
                let newCurrentClient = JSON.parse(global.localStorage.currentClient);
                newCurrentClient.operatingCenter = response.branch;
                newCurrentClient.seller = response.seller;
                this.SessionService.put('currentClient', newCurrentClient);
                this.SessionService.put('cartId', response.cartID);
                this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
                this.shCtrl.userData.globals.currentClient.seller = response.seller;

                this.$rootScope.$broadcast('actualizarHeader',response.branch);
                this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId}).then(response =>{
                  if(!response.error){
                    if (allMessage !== null) {
                      this.showModalAllMessage(allMessage, product, quantity);
                    }
                  }
                });
            } catch (e) {
            }
        } else {
            console.log('ocurrio un error al cambiar de sucursal')
        }
    }).catch(reason => {
        this.state.saving = false;
        this.state.error = true;
    });
}

cambiarSucursalVolumenItemMostrarMedioEnvio(response,product, quantity) {
    let responseData = response
    let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
    let idUsuario = this.shCtrl.globals.currentUser.userId;
    let currentClient  = this.SessionService.get('currentClient');
    let idSucursalActual = currentClient.operatingCenter.id;
    let data = {
        'userId': idUsuario,
        'ciudadId': idCiudad
    };
    this.CartService.getSecondaryBranch(data).then(response => {
        let idSucursalSecundaria = response.listaSucursales[0].id;
        if (idSucursalSecundaria != null) {
            if(idSucursalSecundaria != idSucursalActual){
              this.setSucursalSecundariaMostrarModalMedioEnvio(idSucursalSecundaria, idUsuario, responseData, product, quantity);
            }else{
              this.modalConfirmation(product, quantity);
            }
        }
    });


}

setSucursalSecundariaMostrarModalMedioEnvio(idSucursal, userId, mediosEnvio,product, quantity) {
    let mensajeCambioSucursal = '';
    try {
        mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
    } catch (e) {
    }
    this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
        if (!response.error) {
            // Set the current client
            try {
              let newCurrentClient = JSON.parse(global.localStorage.currentClient);
              newCurrentClient.operatingCenter = response.branch;
              newCurrentClient.seller = response.seller;
              this.SessionService.put('currentClient', newCurrentClient);
              this.SessionService.put('cartId', response.cartID);
              this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
              this.shCtrl.userData.globals.currentClient.seller = response.seller;
              this.$rootScope.$broadcast('actualizarHeader', response.branch);
              this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId}).then(response =>{
                if (!response.error) {
                  if (mensajeCambioSucursal !== '') {
                    let optionsMessage = {
                      title: 'Actualización de precios',
                      isHtml: true,
                      content: mensajeCambioSucursal,
                      size: '',
                      showBottonCancel: false,
                      textActionCancel: '',
                      textAction: 'Aceptar'
                    };
                    let modalInstance = this.$uibModal.open({
                      animation: true,
                      template: modalConfirmation,
                      controller: 'ModalResponseController',
                      controllerAs: 'mdCtrl',
                      backdrop: 'static',
                      size: 'md',
                      resolve: {
                        modalOptions: () => optionsMessage
                      }
                    });
                    modalInstance.result.then(() => {
                      this.showModalSelectModalidadPago(mediosEnvio, product, quantity);
                    }).catch(() => {
    
                    });
                  }
                }
              });
            } catch (e) {
            }
        } else {
            alert('Ocurrion un error al mostrar los medios de envio')
        }
    }).catch(reason => {
        this.state.saving = false;
        this.state.error = true;
    });
}

showModalAllMessage(allMesagge, product, quantity){
    let contentDynamic = 'Se realizaron las siguientes modificaciones: </br>';

    for(let i=0; i < allMesagge.length; i++){
        contentDynamic += `
                            <ul><li>` + allMesagge[i] + `</li></ul>`;
    }

    if(contentDynamic != ''){
        let optionsMessage = {
            title: 'Actualización de precios',
            isHtml: true,
            content: contentDynamic,
            size: '',
            showBottonCancel: false,
            textActionCancel: '',
            textAction: 'Aceptar',
            backdrop: 'static'
        };

        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: 'md',
            backdrop: 'static',
            resolve: {
                modalOptions: () => optionsMessage
            }
        });
        modalInstance.result.then(() => {                
            this.modalConfirmation(product, quantity);
        }).catch(() => {

        });
    }
}

obtenerSucursalSecundaria(cartId, product, quantity) {
  let idCiudad = this.shCtrl.globals.currentClient.operatingCenter.ciudad_id;
  let idUsuario = this.shCtrl.globals.currentUser.userId;
  let currentClient  = this.SessionService.get('currentClient');
  let idSucursalActual = currentClient.operatingCenter.id;
  let data = {
      'userId': idUsuario,
      'ciudadId': idCiudad
  };
  // Si la modalidad es recoge 
  if (data != null) {
      this.CartService.getSecondaryBranch(data).then(response => {
          let idSucursalSecundaria = response.listaSucursales[0].id;
          if (idSucursalSecundaria != null) {
              if(idSucursalSecundaria != idSucursalActual){
                this.setSucursalSecundariaSinModalidad(idSucursalSecundaria, idUsuario, product, quantity);
              }else{
                this.modalConfirmation(product, quantity);
              }             
          }
      });
      this.CartService.updateDateCart(cartId).then(response => {
          return response;
      });
  }
}

setSucursalSecundariaSinModalidad(idSucursal, userId, product, quantity) {

  let mensajeCambioSucursal = '';
  let allMessage = [];
  try {
      mensajeCambioSucursal = this.shCtrl.globalParams.cmsInfo.B2B_MENSAJE_CAMBIO_SUCURSAL;
      allMessage.push(mensajeCambioSucursal);
  } catch (e) {
  }
  this.SharedService.setOperatingCenter({ 'userId': userId, 'operatingCenterId': idSucursal, 'origen': 'b2b' }).then(response => {
      if (!response.error) {
          // Set the current client
          try {
              let newCurrentClient = JSON.parse(global.localStorage.currentClient);
              newCurrentClient.operatingCenter = response.branch;
              newCurrentClient.seller = response.seller;
              this.SessionService.put('currentClient', newCurrentClient);
              this.SessionService.put('cartId', response.cartID);
              this.shCtrl.userData.globals.currentClient.operatingCenter = response.branch;
              this.shCtrl.userData.globals.currentClient.seller = response.seller;

              this.$rootScope.$broadcast('actualizarHeader', response.branch);
              this.SharedService.assignWarehouseBasketCode({ 'cartId': this.shCtrl.cart.cartId}).then(response =>{
                if(!response.error){
                  if (allMessage !== null) {
                    this.showModalAllMessage(allMessage, product, quantity);
                  }
                }
              });
          } catch (e) {
          }
      } else {
          console.log('Ocurrio un erro al cambiar la sucursal')
      }
  }).catch(reason => {
      this.state.saving = false;
      this.state.error = true;
  });
}


}

FeaturedProductsController.$inject = inject;

export default FeaturedProductsController;




/** WEBPACK FOOTER **
 ** ./www/components/catalog/featured-products/featured-products.controller.js
 **/